import { useState } from 'react';

export default function FloatingButtons() {
  const [showFinancePopup, setShowFinancePopup] = useState(false);
  const [showParkingPopup, setShowParkingPopup] = useState(false);

  return (
    <>
      {/* Floating Buttons Container - Only visible on desktop (lg and above) */}
      <div className="hidden lg:flex fixed bottom-40 right-6 z-40 flex-col gap-3">
        {/* 0% Finance Button */}
        <button
          onClick={() => setShowFinancePopup(true)}
          className="group bg-gradient-to-r from-[#d0a24f] to-[#dcb964] text-white px-6 py-3 rounded-full shadow-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer font-semibold"
        >
          <i className="ri-percent-line text-xl"></i>
          0% Finance Available
        </button>

        {/* Free Parking Button */}
        <button
          onClick={() => setShowParkingPopup(true)}
          className="group bg-[#444c42] text-white px-6 py-3 rounded-full shadow-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer font-semibold"
        >
          <i className="ri-parking-box-line text-xl"></i>
          Free Parking
        </button>
      </div>

      {/* Finance Popup */}
      {showFinancePopup && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={() => setShowFinancePopup(false)}>
          <div className="bg-white rounded-3xl p-8 max-w-md w-full shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-2xl font-bold text-[#444c42]">0% Interest-Free Finance</h3>
              <button
                onClick={() => setShowFinancePopup(false)}
                className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl text-gray-600"></i>
              </button>
            </div>

            <div className="space-y-4 mb-6">
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5"></i>
                <p className="text-[#7A8178]">Spread the cost of your treatment with 0% interest</p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5"></i>
                <p className="text-[#7A8178]">Flexible payment plans available</p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5"></i>
                <p className="text-[#7A8178]">Quick and easy application process</p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5"></i>
                <p className="text-[#7A8178]">No hidden fees or charges</p>
              </div>
            </div>

            <a
              href="#contact"
              onClick={() => setShowFinancePopup(false)}
              className="block w-full bg-gradient-to-r from-[#d0a24f] to-[#dcb964] text-white py-3 rounded-full font-semibold text-center hover:shadow-xl transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Learn More
            </a>
          </div>
        </div>
      )}

      {/* Parking Popup */}
      {showParkingPopup && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={() => setShowParkingPopup(false)}>
          <div className="bg-white rounded-3xl p-8 max-w-md w-full shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-2xl font-bold text-[#444c42]">Free Parking Available</h3>
              <button
                onClick={() => setShowParkingPopup(false)}
                className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl text-gray-600"></i>
              </button>
            </div>

            <div className="space-y-4 mb-6">
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5"></i>
                <p className="text-[#7A8178]">Three hours of complimentary onsite parking</p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5"></i>
                <p className="text-[#7A8178]">Large, spacious car park for stress-free visits</p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5"></i>
                <p className="text-[#7A8178]">No fees or time limits to worry about</p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5"></i>
                <p className="text-[#7A8178]">Convenient parking right outside the practice</p>
              </div>
            </div>

            <button
              onClick={() => setShowParkingPopup(false)}
              className="block w-full bg-gradient-to-r from-[#444c42] to-[#7A8178] text-white py-3 rounded-full font-semibold text-center hover:shadow-xl transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Got It
            </button>
          </div>
        </div>
      )}
    </>
  );
}
